import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { FiatActionButton } from './FiatActionButton'
import { FiatReceipt } from './FiatReceipt'

/**
 * What the buyer sees when fiat deposits are not served where they are.
 *
 * It wears the restricted receipt because the situation has the same shape:
 * nothing to retry, and support is the only thing left to do. Its one action
 * leaves, since there is no flow to continue into.
 */
export function FiatRegionUnsupportedScreen({
  onClose,
}: {
  onClose: () => void
}) {
  const { t } = useFunkitTranslation()
  return (
    <FiatReceipt
      restricted
      title={t('fiat.regionUnsupportedTitle')}
      supportLabel={t('fiat.kycGetHelpSupport')}
    >
      <FiatActionButton label={t('common.close')} onPress={onClose} />
    </FiatReceipt>
  )
}
